import React from 'react';
import Header from '../../components/Header';
import HeroSection from '../../components/WhyPVC/HeroSection';
import Productos from '../../components/Productos';
import Separador from '../../components/Separador';
import Footer from '../../components/Footer';
import ImageBg from '../Pisos/ImageBg';
import CardsCarousel from '../Pisos/CardsCarousel';
import IconText from '../Pisos/IconText';
import { Helmet } from 'react-helmet';

export default function WallPanelInterior() {
  let ITEMS=[
    {
      image: "/WallPanel/TP_WP_EUCALYPTUS_1MOD.webp",
      title: "Eucalyptus"
    },
    {
      image: "/WallPanel/TP_WP_OAK_1MOD.webp",
      title: "Oak"
    },
    {
      image: "/WallPanel/TP_WP_POPLAR_1MOD.webp",
      title: "Poplar"
    },
    {
      image: "/WallPanel/TP_WP_TEEK_1MOD.webp",
      title: "Teek"
    },
    {
      image: "/WallPanel/TP_WP_WALNUT_1MOD.webp",
      title: "Walnut"
    },
  ]
  let array=[
    {
      image: "aislacion-termica.webp",
      text: "Gran confort térmico."
    },
    {
      image: "estanquidad.webp",
      text: "Antialérgico, antihumedad, antimanchas, antitermitas."
    },
    {
      image: "mantenimiento.webp",
      text: "No requiere mantenimiento."
    },
    {
      image: "limpieza.webp",
      text: "Fácil de instalar y de limpiar."
    },
  ]
  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Paneles de PVC que renuevan ambientes con instalación rápida, mejor limpieza y apoyo a la aislación."
        />
        <title>Wall Panel Interior: revestimiento de PVC sin obra</title>
      </Helmet>
      <Header />
      <HeroSection title="Wall Panel Interior" subtitle="Paneles de PVC que renuevan ambientes con instalación rápida" image="/houses/house-banner.webp" />
      <Productos padding="0px">
        <div className='row section-padding'>
          <div className='col-lg-7 col-12'>
            <h2>Interior</h2>
            <Separador color="--color-3" width="100px" />
            <p>Aplicaciones de diseño interior, decoración y acabados arquitectónicos.</p>
            <p>Se puede colocar directamente sobre todo tipo de paredes (inclusive fuera de plomo o irregulares), áreas cementadas y otros materiales, también atornillado sobre alfajias.</p>
            <ul>
              <li><b>Diseño</b></li>
              <li><b>Confort</b></li>
              <li><b>Versatilidad</b></li>
            </ul>
          </div>
          <div className='col-lg-5 col-12'>
            <img src="/WallPanel/wall-panel-interior-contexto.webp" alt="wall-panel-interior-contexto" />
          </div>
        </div>
        <ImageBg image="/houses/sample-02.webp">
          <h2>Una gran variedad de colores y texturas</h2>
          <Separador color="--color-2" width="100px" />
          <p>con la resistencia y durabilidad del PVC, garantizando una solución ideal para cada ambiente.</p>
          <CardsCarousel items={ITEMS} colorTitle="--color-4" />
        </ImageBg>
        <div className='section-padding'>
          <IconText array={array} gutter="5" cols="4" imgSize="100px" />
        </div>
        <div className='section-padding'>
          <iframe width="100%" height="600" src="https://www.youtube.com/embed/qzCFlZDtGnU" title="GUÍA DE INSTALACIÓN - WALL PANEL PVC IN &amp; OUT DESIGN MUCHTEK" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
        <div className='row section-padding'>
          <div className='col-lg-8'>
            <h2><b>Interior</b> y Exterior</h2>
            <Separador color="--color-3" width="100px" />
            <p>Diseñado para tener la apariencia y textura de la madera natural con la resistencia y durabilidad del PVC.</p>
          </div>
          <div className='col-lg-4'>
            <img src="/WallPanel/wall-panel-renders.webp" alt="wall-panel-renders" />
          </div>
          <div className='col-lg-12'>
            <img src="/WallPanel/tipologias-wallpanel-01.webp" alt="tipologias-wallpanel-01" />
          </div>
        </div>
        <div className='section-padding'>
          <h2 className='mt-4'>Descarga nuestros <b>catálogos digitales</b></h2>
          <Separador width="100px" color="--color-3" />
          <div className='row g-4 catalogo-section'>
            <div className='col'>
              <p>Brochure institucional Muchtek</p>
              <span className='d-flex align-items-center'>
                <i className="bi bi-filetype-pdf"></i>
                <a href="/CatalogoMuchtek/brochure-muchtek.pdf">Descargar</a>
              </span>
            </div>
            <div className='col'>
              <p>Flyer ADN Muchtek</p>
              <span className='d-flex align-items-center'>
                <i className="bi bi-filetype-pdf"></i>
                <a href="/CatalogoMuchtek/flyer-adn-muchtek.pdf">Descargar</a>
              </span>
            </div>
            <div className='col'>
              <p>Díptico laminados Muchtek</p>
              <span className='d-flex align-items-center'>
                <i className="bi bi-filetype-pdf"></i>
                <a href="/CatalogoMuchtek/flyer-laminados-muchtek.pdf">Descargar</a>
              </span>
            </div>
            <div className='col'>
              <p>Brochure In&Out Design Muchtek</p>
              <span className='d-flex align-items-center'>
                <i className="bi bi-filetype-pdf"></i>
                <a href="/CatalogoMuchtek/brochure-in&outdesign-2024.pdf">Descargar</a>
              </span>
            </div>
          </div>
        </div>
      </Productos>
      <Footer />
    </>
  )
}
